document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('variant-selector-modal');
  if (!modal) return;

  const modalTitle = modal.querySelector('#variant-modal-title');
  const modalImageWrapper = modal.querySelector('#variant-modal-product-image-wrapper');
  const modalDescriptionWrapper = modal.querySelector('#variant-modal-product-description-wrapper');
  const modalBody = modal.querySelector('#variant-modal-product-details');

  const openModal = (product) => {
    modalTitle.textContent = product.title;

    // Populate product image
    modalImageWrapper.innerHTML = '';
    if (product.featured_image) {
      const img = document.createElement('img');
      img.src = product.featured_image.replace(/(\.[^.]*)$/, '_300x$1');
      img.alt = product.title;
      modalImageWrapper.appendChild(img);
    }

    // Populate expandable description
    modalDescriptionWrapper.innerHTML = '';
    if (product.description) {
      const details = document.createElement('details');
      const summary = document.createElement('summary');
      summary.textContent = 'Description';
      const content = document.createElement('div');
      content.className = 'description-content';
      content.innerHTML = product.description;
      details.appendChild(summary);
      details.appendChild(content);
      modalDescriptionWrapper.appendChild(details);
    }
    
    modalBody.innerHTML = '';
    
    const optionName = product.options[0];
    const wrapper = document.createElement('div');
    wrapper.className = 'option-buttons-wrapper';
    
    const title = document.createElement('p');
    title.className = 'option-buttons-title';
    title.textContent = `Select ${optionName}:`;
    wrapper.appendChild(title);

    product.variants.forEach(variant => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'option-button';
      button.textContent = variant.option1;
      button.dataset.variantId = variant.id;
      if (!variant.available) button.disabled = true;
      wrapper.appendChild(button);
    });

    modalBody.appendChild(wrapper);
    modal.style.display = 'flex';
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    modal.style.display = 'none';
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  document.body.addEventListener('click', (event) => {
    const toggle = event.target.closest('.card-options-toggle');
    if (toggle) {
      event.preventDefault();
      const productItem = toggle.closest('[data-json-product]');
      if (productItem) {
        try {
          const productData = JSON.parse(productItem.dataset.jsonProduct);
          openModal(productData);
        } catch (e) {
          console.error('Could not parse product JSON:', e);
        }
      }
    }
  });
  
  modal.addEventListener('click', (event) => {
    const optionButton = event.target.closest('.option-button');
    if (optionButton && !optionButton.disabled) {
      const variantId = optionButton.dataset.variantId;
      optionButton.disabled = true;

      // Step 1: Add the item to the cart.
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(error => { throw new Error(error.description || 'Could not add item.'); });
        }
        return response.json();
      })
      .then(() => {
        // Step 2: Fetch the updated side cart HTML using the theme's specific internal view.
        // This is the key step discovered from theme.js.
        return fetch('/cart?view=ajax_side_cart');
      })
      .then(response => response.text())
      .then(html => {
        // Step 3: Replace the content of the side cart's inner wrapper.
        const cartContentWrapper = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
        if (cartContentWrapper) {
          cartContentWrapper.innerHTML = html;
          // Manually execute any scripts in the new HTML to initialize components
          Array.from(cartContentWrapper.getElementsByTagName("script")).forEach(oldScript => {
            const newScript = document.createElement("script");
            Array.from(oldScript.attributes).forEach( attr => newScript.setAttribute(attr.name, attr.value) );
            newScript.appendChild(document.createTextNode(oldScript.innerHTML));
            oldScript.parentNode.replaceChild(newScript, oldScript);
          });
        } else {
          throw new Error('Side cart content wrapper not found. Could not refresh.');
        }

        // Step 4: Fetch the cart object to update the header count.
        return fetch('/cart.js');
      })
      .then(response => response.json())
      .then(cart => {
        const cartCountBubble = document.querySelector('[data-cart-count]');
        if (cartCountBubble) {
          cartCountBubble.textContent = cart.item_count;
        }
        
        // Step 5: Close the modal and show the updated side cart.
        closeModal();
        document.body.classList.add('cart-sidebar-show');
      })
      .catch(e => {
        console.error('AJAX Cart Error:', e);
        // Fallback to redirect on any error.
        window.location.href = '/cart';
      });
    }
  });

  modal.addEventListener('click', (event) => {
    if (event.target.matches('[data-close-modal]')) closeModal();
  });
  
  document.addEventListener('keydown', (event) => {
    if(event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });
});